<template>
   <div :class="['basic-header-approve', isDisabled]">
        <div class="basic-header-title">
          <span class="basic-header-name">{{
            auditDetail && auditDetail.organizationName
          }}</span>
        </div>
        <div class="basic-header-steps">
          <el-steps :active="active" align-center>
            <el-step
              v-for="(item, index) in stepsList"
              :key="index"
              :title="item"
            />
          </el-steps>
        </div>
      </div>
</template>

<script>
import mixin from '../../../mixins/auditFlowManage'

export default {
  name: 'approveHeader',
  mixins: [mixin],
  props: ['active', 'isDisabled'],
}
</script>

<style lang="scss" scoped>
.basic-header {
  &-approve {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1;
    display: flex;
    height: 84px;
    padding: 16px 0;
    background: #fff;
  }
  &-title {
    width: 250px;
  }
  &-name {
    font-size: 16px;
    font-weight: 600;
    margin-right: 4px;
  }
  &-steps {
    width: 65%;
  }
}
</style>
